import { useState } from "react";
import { useForm } from "react-hook-form";
import * as Sentry from "@sentry/nextjs";
import { useToast } from "~/utils";
import { Content } from "~/components/aud/base/Content";
import { SectionTitle } from "~/components/aud/base/Section";
import { FormSubmitButton } from "~/components/FormSubmitButton";
import { EmailField } from "~/components/settings/EmailField";
import { PasswordField } from "~/components/settings/PasswordField";
import css from "./SetEmailAndPasswordForm.module.scss";
import { useUpdateMeMutation } from "~/hooks/rtk-query-api";

export const SetEmailAndPasswordForm = () => {
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [updateMe] = useUpdateMeMutation();

  const onSubmit = async (data: { email: string; password: string }) => {
    try {
      setLoading(true);
      await updateMe({
        updateMeInput: {
          email: data.email,
          password: data.password,
        },
      }).unwrap();
      toast.success("アカウント登録に成功しました。");
    } catch (e) {
      Sentry.captureException(e);
      if (e.status === 409) {
        toast.error(e.data?.error ?? "エラーが発生しました。お手数ですがもう一度時間を開けておためしください。");
        return;
      }
      toast.error("エラーが発生しました。お手数ですがもう一度時間を開けておためしください。");
    } finally {
      setLoading(false);
      reset();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} key={2}>
      <Content>
        <SectionTitle>メールアドレス・パスワードの登録</SectionTitle>
        <div className="_form">
          <div className="field">
            メールアドレス・パスワードを登録すると以下の機能を利用できます。
            <ul className={css.items}>
              <li>アプリへのログイン</li>
              <li>提携校を卒業した後のアカウント利用</li>
            </ul>
            ※提携校卒業後、NowDoプレミアムは無効になります
          </div>
          <EmailField register={register} errors={errors} />
          <PasswordField register={register} errors={errors} />
        </div>
        <p className={css.button}>
          <FormSubmitButton size="medium" loading={loading}>
            登録する
          </FormSubmitButton>
        </p>
      </Content>
    </form>
  );
};
